/* eslint-disable camelcase */
import React from 'react';
import { cancelButton, save, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import vars from '../../theme/vars';
import AddRule1 from './Add1';
import RulesList from './ListForSA';
// import RulesListsSA from './ListForSANew/RuleListsSA';

import EditRule from './Edit';
import RulesListForDealer from './ListForDealer';
import ViewRule from './View';
import { IconButton } from '../../app-components/buttons/Buttons';
import { addIcon, back_Icon, editDealerLogo } from '../../images';

const { headings } = vars;

export default {
  [ROUTES.avRuleAdd1.name]: {
    screen: AddRule1,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Add New Rule</Text>,
    headerActions: [cancelButton, save],
  },

  [ROUTES.avRulesView.name]: {
    screen: ViewRule,
    screenProps: {
      editable: false,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Rule Details</Text>,
    headerActions: [
      // cancelButton,
      {
        render: (props) => (
          <IconButton
            description="Back"
            tooltipId="go-back"
            icon={back_Icon}
            style={{ usingIcon: true }}
            iconStyle={{ height: 20, width: 20 }}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
            imageStyle={{ width: 35, height: 35 }}
            onClick={() => {
              props.eventDispatcher.notify('AVRulesListReload');
              props.navigation.pop();
            }}
          />
        ),
      },
      {
        render: () => (
          <IconButton
            description="Edit Rule"
            tooltipId="edit-rule"
            icon={editDealerLogo}
            style={{ usingIcon: true }}
            iconStyle={{ height: 20, width: 20 }}
            stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          />
        ),
        type: 'link',
        link: (props) => ({
          view: ROUTES.avRuleEdit.name,
          params: {
            item: { ...props?.navigation?.state?.params.item },
          },
        }),
      },
    ],
  },

  [ROUTES.avRuleEdit.name]: {
    screen: EditRule,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Edit Rule</Text>,
    headerActions: [cancelButton, save],
  },

  [ROUTES.avRulesListSA.name]: {
    screen: RulesList,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>All Rules</Text>,
    headerActions: [
      {
        render: () => <Text> </Text>,
      },
    ],
  },

  ['av-rules-list-new']: {
    screen: RulesList,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>All Rules</Text>,
    headerActions: [
      {
        render: () => <Text> </Text>,
      },
    ],
  },


  [ROUTES.avRulesListDealer.name]: {
    screen: RulesListForDealer,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>All Rules</Text>,
    headerActions: [
      {
        render: () => (
          <IconButton
            icon={addIcon}
            description="Add New Rule"
            tooltipId="add-new-rule"
            label="Add Rule"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: {
          view: ROUTES.avRuleAdd1.name,
          push: true,
          expanded: true,
        },
      },
    ],
  },
};
